export default __webpack_public_path__ + "static/media/CONTATO-PLAN-LO-QUIERO-v3.594623c7.pdf";